import { render, staticRenderFns } from "./my-order.vue?vue&type=template&id=466a863a&scoped=true"
import script from "./my-order.vue?vue&type=script&lang=js"
export * from "./my-order.vue?vue&type=script&lang=js"
import style0 from "./my-order.vue?vue&type=style&index=0&id=466a863a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466a863a",
  null
  
)

export default component.exports